__turbopack_context__.v({
  "close": "toast-module__cIQOPG__close",
  "container": "toast-module__cIQOPG__container",
  "error": "toast-module__cIQOPG__error",
  "info": "toast-module__cIQOPG__info",
  "message": "toast-module__cIQOPG__message",
  "slideIn": "toast-module__cIQOPG__slideIn",
  "success": "toast-module__cIQOPG__success",
  "toast": "toast-module__cIQOPG__toast",
  "warning": "toast-module__cIQOPG__warning",
});
